// src/components/MeetingHeader.tsx
import React from "react";
import { Button } from "@/components/ui/button";
import {  LogOut, MessageCircleHeart } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../../ui/alert-dialog";
import canara from "../../../../public/CANBK.png";
interface MeetingHeaderProps {
  meetingName: string;
  participantsCount: number;
  onLeaveMeeting: () => void;
  onOpenChat: () => void;
  unreadMessageCount: number;
}

const MeetingHeader: React.FC<MeetingHeaderProps> = ({
  meetingName,
  participantsCount,
  onLeaveMeeting,
  onOpenChat,
  unreadMessageCount,
}) => {
  return (
    <div className="flex items-center justify-between h-16 m-2 p-1 md:px-3 bg-white rounded-t-xl">
      <div className="flex items-center space-x-2">
        <Button
          variant="ghost"
          size="icon"
          className="text-gray-500 bg-blue-50 rounded-full p-2 hover:bg-blue-100"
        >
          {/* <ChevronLeft className="h-5 w-5" /> */}
          <img src={canara} className="w-5 h-5" alt="" />
        </Button>
        <div>
          <h2 className="md:text-lg text-sm font-semibold text-gray-800">
            {meetingName}
          </h2>
          <p className="text-sm text-gray-500">
            {participantsCount} Participants
          </p>
        </div>
      </div>
      <div className="flex items-center space-x-2">
        <div className="relative">
          <MessageCircleHeart
            className="h-7 w-7 text-gray-800 hover:text-gray-950 cursor-pointer p-0"
            onClick={onOpenChat}
          />
          {unreadMessageCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center animate-bounce">
              {unreadMessageCount}
            </span>
          )}
        </div>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              variant="destructive"
              className="px-4 py-2 rounded-full text-red-600 bg-red-100 text-sm font-medium flex items-center space-x-1"
            >
              <LogOut className="h-4 w-4" />
              <span>Leave Meeting</span>
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-white text-black border-0">
            <AlertDialogHeader>
              <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
              <AlertDialogDescription>
                This action cannot be undone. This will end your call.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel className="bg-blue-500 text-white">
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                className="bg-red-500 text-white"
                onClick={onLeaveMeeting}
              >
                Continue
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
        {/* <Button
          variant="destructive"
          className="px-4 py-2 rounded-full text-red-600 bg-red-100 text-sm font-medium flex items-center space-x-1"
          onClick={onLeaveMeeting}
        >
          <LogOut className="h-4 w-4" />
          <span>Leave Meeting</span>
        </Button> */}
      </div>
    </div>
  );
};

export default MeetingHeader;
